export default __webpack_public_path__ + "static/media/Contract@32.edd614ed.svg";